// Translations for the System Logs page (frontend/src/pages/SystemLogs/SystemLogs.js)
// and the clear action on the SMS Logs page.
const systemLogsDict = [
  { en: "System Logs", sw: "Kumbukumbu za Mfumo" },
  { en: "Errors and events recorded by the server", sw: "Hitilafu na matukio yaliyorekodiwa na seva" },
  { en: "files", sw: "faili" },
  { en: "Clear all logs", sw: "Futa logs zote" },
  { en: "No log files.", sw: "Hakuna faili za logs." },
  { en: "Search messages", sw: "Tafuta ujumbe" },
  { en: "All levels", sw: "Viwango vyote" },
  { en: "Delete this file", sw: "Futa faili hili" },
  { en: "This file is large; only its most recent part is shown.", sw: "Faili hili ni kubwa; sehemu yake ya karibuni tu ndiyo inaonyeshwa." },
  { en: "No entries match.", sw: "Hakuna kumbukumbu zinazolingana." },
  { en: "Delete this log file? This cannot be undone.", sw: "Futa faili hili la logs? Haiwezi kurejeshwa." },
  { en: "Delete ALL system log files? This cannot be undone.", sw: "Futa faili ZOTE za logs za mfumo? Haiwezi kurejeshwa." },
  { en: "log files deleted.", sw: "faili za logs zimefutwa." },
  { en: "Log file deleted.", sw: "Faili la logs limefutwa." },
  { en: "Clear SMS logs", sw: "Futa kumbukumbu za SMS" },
  { en: "Delete ALL SMS records? This cannot be undone.", sw: "Futa kumbukumbu ZOTE za SMS? Haiwezi kurejeshwa." },
  { en: "SMS records deleted.", sw: "kumbukumbu za SMS zimefutwa." },
];

export default systemLogsDict;
